import { configureStore } from '@reduxjs/toolkit'
import { reduxReducer } from './reducer'

// TODO: https://stackoverflow.com/questions/35622588/how-to-reset-the-state-of-a-redux-store

export default configureStore({
  reducer: reduxReducer,
})
